export default __webpack_public_path__ + "static/media/mmg_logo_transparent.b93cc16c.png";